import { Stack, Text } from '@chakra-ui/react'
import { CustomLinkOverlay } from 'BrokerTsLib/src/components'
import type { ShortInsuranceGridItem } from 'BrokerTsLib/src/dtos'
import { formatDate } from 'BrokerTsLib/src/Utils/formatPrice'

import { formatDateTime } from '@/utils/formatDate'

import { TableData, TableRow } from '../../components/Grid'

export const logoSize = 44

export const ShortInsuranceRow = ({
  item,
}: {
  item: ShortInsuranceGridItem
}) => {
  const { id } = item

  const subject = `${item?.makeBase ?? ''} ${item?.modelBase ?? ''}`.trim()
  const brokerFullName =
    `${item.createdBy?.name ?? ''} ${item.createdBy?.surname ?? ''}`.trim()

  return (
    <CustomLinkOverlay as={TableRow} to={`/shortInsurance/${id}`}>
      <TableData>
        {item.contractNumber && (
          <Text
            sx={{
              color: 'primary.400',
              fontSize: 'xl',
              fontWeight: 'semibold',
            }}
          >
            {item.contractNumber}
          </Text>
        )}
      </TableData>

      <TableData>
        {item.contractCreatedDate && (
          <Text sx={{ fontSize: 'sm' }}>
            {formatDateTime(item.contractCreatedDate)}
          </Text>
        )}
      </TableData>

      <TableData>
        {item.insuranceStartDate && (
          <Text sx={{ fontSize: 'sm', fontWeight: 'semibold' }}>
            {formatDate(item.insuranceStartDate, 'D.M.YYYY')}
          </Text>
        )}
      </TableData>

      <TableData>
        {item.insuranceEndDate && (
          <Text sx={{ fontSize: 'sm', fontWeight: 'semibold' }}>
            {formatDate(item.insuranceEndDate, 'D.M.YYYY')}
          </Text>
        )}
      </TableData>

      <TableData>{item.vin && <Text>{item.vin}</Text>}</TableData>

      <TableData sx={{ pl: 0 }}>
        {!!subject && (
          <Text
            sx={{
              overflow: 'hidden',
              textOverflow: 'ellipsis',
              whiteSpace: 'nowrap',
            }}
          >
            {subject}
          </Text>
        )}
      </TableData>

      <TableData>
        {brokerFullName && (
          <Stack gap={0}>
            <Text
              sx={{
                color: 'primary.500',
                fontSize: 'sm',
                fontWeight: 'semibold',
              }}
            >
              {brokerFullName}
            </Text>
            <Text
              sx={{
                fontSize: 'xs',
                lineHeight: 4,
              }}
            >
              {item.createdBy?.ouName}
            </Text>
          </Stack>
        )}
      </TableData>
    </CustomLinkOverlay>
  )
}
